module.exports = __webpack_public_path__ + "img/coach.d47adad9.png";